import { useState, useEffect, useCallback } from "react";
import ApiConfig from "../services/ApiConfig";
import axios from "axios";

const ACTION_TYPES = ["capture", "bug_fix", "rist_restart", "keep_alive"];

const EMPTY_LOGS = ACTION_TYPES.reduce((logs, actionType) => {
    logs[actionType] = [];
    return logs;
}, {});

const GetActionLogs = (eventId) => {
    return new Promise(async (resolve, reject) => {
        try {
            const config = await ApiConfig();
            config.method = "get";
            config.url += "/get_action_logs?event_id=" + eventId;
            const response = await axios(config);
            resolve(response.data);
        } catch (error) {
            reject(error.response ? error.response.data : error.message);
        }
    });
};

/**
 * Fetches every recorded action for an event in one call. Each Actions card
 * renders its own slice, so the four cards share a single request.
 */
const useGetActionLogs = (eventId) => {
    const [error, setError] = useState(null);
    const [isLoaded, setIsLoaded] = useState(false);
    const [logs, setLogs] = useState(EMPTY_LOGS);

    const refetchActionLogs = useCallback(async () => {
        try {
            const response = await GetActionLogs(eventId);
            setLogs({ ...EMPTY_LOGS, ...response });
            setError(null);
            setIsLoaded(true);
        } catch (error) {
            setError(error);
            setIsLoaded(true);
        }
    }, [eventId]);

    useEffect(() => {
        if (eventId) {
            refetchActionLogs();
        }
    }, [eventId, refetchActionLogs]);

    return { logs, error, isLoaded, refetchActionLogs };
};

export default useGetActionLogs;
